// A simple file that exports a new vue instance, you can then listen to events emitted on that Vue instance
import Vue from 'vue'
export default new Vue()